import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-sheet',
  templateUrl: './component-sheet.page.html',
  styleUrls: ['./component-sheet.page.scss'],
})
export class ComponentSheetPage implements OnInit {
  public mock = [
    { value: 'US', viewValue: 'US' },
    { value: 'Chile', viewValue: 'Chile' },
    { value: 'Canada', viewValue: 'Canada' },
  ];

  constructor() { }

  ngOnInit() {
  }

}
